import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import classNames from 'classnames';
import * as AlertBanner from '../../subkit-ui/basic/AlertBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var BaseTWTopNav = function BaseTWTopNav(_ref) {
  var currentUser = _ref.currentUser,
      leftSlot = _ref.leftSlot,
      navLinks = _ref.navLinks,
      onClose = _ref.onClose,
      rightSlot = _ref.rightSlot;
  return /*#__PURE__*/_jsx("nav", {
    className: "mx-auto py-3 bg-white",
    children: /*#__PURE__*/_jsxs("div", {
      className: "min-w-full grid grid-cols-1 gap-4",
      children: [currentUser !== null && currentUser !== void 0 && currentUser.limited ? /*#__PURE__*/_jsx(AlertBanner.Root, {
        type: "error",
        children: /*#__PURE__*/_jsxs(AlertBanner.Content, {
          children: ["Based on your revenue, it's time to upgrade to Subkit\u2019s Paid Plan.", ' ', /*#__PURE__*/_jsx(Link, {
            href: "/dashboard/account-settings/billing",
            children: /*#__PURE__*/_jsx("a", {
              children: "Upgrade now."
            })
          })]
        })
      }) : null, /*#__PURE__*/_jsxs("div", {
        className: "flex justify-between px-2",
        children: [/*#__PURE__*/_jsx("div", {
          children: leftSlot
        }), /*#__PURE__*/_jsxs("div", {
          className: "hidden sm:ml-6 md:flex sm:items-center",
          children: [/*#__PURE__*/_jsx("div", {
            className: "sm:space-x-6 mr-8",
            children: navLinks.map(function (navLink) {
              return !navLink.hidden && navLink.href && /*#__PURE__*/_jsx(Link, {
                href: navLink.href,
                children: /*#__PURE__*/_jsx("a", {
                  className: classNames('clickable text-gray-500 hover:text-subkit-primary inline-flex items-center py-1 font-medium', {
                    'px-1': navLink.type !== 'button',
                    'border border-gray-300 hover:border-subkit-primary rounded px-4': navLink.type === 'button'
                  }),
                  target: navLink.external ? '_blank' : '_self',
                  rel: navLink.external && 'noopener noreferrer',
                  children: navLink.text
                })
              }, navLink.text);
            })
          }), rightSlot]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex items-center md:hidden",
          children: /*#__PURE__*/_jsxs("button", {
            className: "inline-flex bg-transparent items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
            "aria-expanded": "false",
            onClick: onClose,
            children: [/*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: "Open main menu"
            }), /*#__PURE__*/_jsx("svg", {
              className: "block h-6 w-6",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "aria-hidden": "true",
              children: /*#__PURE__*/_jsx("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M4 6h16M4 12h16M4 18h16"
              })
            })]
          })
        })]
      })]
    })
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.auth.users.current
  };
};

export var TWTopNav = connect(mapStateToProps, {})(BaseTWTopNav);